import {
  GpsFixedOutlined,
  NotListedLocation
} from '@material-ui/icons';
import {
  withStyles,
} from "@material-ui/core";

const styles = theme => ({
  notListedLocationStyle: {
    color: theme.HeaderSelectedText,
    fontSize: "large",
    margin: "2px 5px"
  },
  gpsFixedOutlinedStyle: {
    color: theme.iconColor,
    margin: "2px 5px"
  },
});

const RenderIcon = withStyles(styles)((props) => {
  const {field, classes} = props
  switch (field) {
    case "icon-geoCoded":
        return <GpsFixedOutlined className={classes.gpsFixedOutlinedStyle}/>
    case "icon-notGeoCoded":
        return <NotListedLocation className={classes.notListedLocationStyle}/>
    default:
      return null;
  }
})

const iconRenderer = (field) => {
  return <RenderIcon field={field}/>
}

export default iconRenderer;